export default {"src":"/_next/static/media/circle_info_40.5833bc81.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};